import type { StandbyPublicShopData } from '@/api/standby/standbyPublicShopQuery';

/** The shop's own switch is off; Squire's switch is `settings.available`. */
export const isShopStandbyOff = ({ shop, settings }: StandbyPublicShopData) =>
  shop.enabled === false || !settings.standbyEnabled || !settings.walkInEnabled;
